import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "src/app/share/service/alert.service";
import { ResetPasswordValidators } from "../../class/reset-password-validators";
import { UserDataService } from "../../data-service/user.data.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
	selector: "app-change-password",
	templateUrl: "./change-password.component.html",
	styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
	passwordGroup: UntypedFormGroup;
	hide: boolean = false;

	constructor(
		private bottomSheetRef: MatBottomSheetRef<ChangePasswordComponent>,
		private ngxSpinnerService: NgxSpinnerService,
		private alertService: AlertService,
		private userDataService: UserDataService,
		private translateService: TranslateService,
	) {}

	ngOnInit(): void {
		this.passwordGroup = new UntypedFormGroup(
			{
				currentPassword: new UntypedFormControl(null, [Validators.required]),
				newPassword: new UntypedFormControl(
					"",
					Validators.compose([
						Validators.minLength(8),
						Validators.required,
						Validators.pattern("^(?=.*[!?@#$%^&+=]).*$"), //Special character required
					]),
				),
				repeatNewPassword: new UntypedFormControl(""),
			},
			{ validators: [ResetPasswordValidators.PasswordMatchValidator] },
		);
	}

	public get passwordErrorMessage(): string {
		const form: UntypedFormControl = this.passwordGroup.get(
			"newPassword",
		) as UntypedFormControl;
		return form.hasError("required")
			? this.translateService.instant("error.newPassRequired")
			: form.hasError("minlength")
			? this.translateService.instant("error.condition_2")
			: form.hasError("pattern")
			? this.translateService.instant("error.condition_3")
			: "";
	}

	public submit(): void {
		this.ngxSpinnerService.show();
		let obj = {
			oldPassword: encodeURIComponent(this.passwordGroup.value.currentPassword),
			newPassword: encodeURIComponent(this.passwordGroup.value.newPassword),
			confirmNewPassword: encodeURIComponent(this.passwordGroup.value.repeatNewPassword),
		};

		this.userDataService.updatePassword(obj).subscribe({
			next: (x) => {
				this.ngxSpinnerService.hide();
				this.bottomSheetRef.dismiss(true);
				this.alertService.openSnackBar("Successfully updated account password");
			},
			error: (err) => {
				this.ngxSpinnerService.hide();
				if (err.error) {
					this.alertService.openSnackBar(`Error: ${err.error}`);
				} else {
					this.alertService.openSnackBar(`Error updating account password`);
				}
			},
		});
	}

	close(event: MouseEvent): void {
		this.bottomSheetRef.dismiss();
		event.preventDefault();
	}
}
